import ExcelJS from "exceljs";

export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  let csv = headers.map(escape).join(",") + "\r\n";

  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

// export function exportGuestCountsByHourCSV(
//   transactions,
//   countTransaction,
//   range,
//   fileName
// ) {
//   // 1) count per hour (imports your existing logic)
//   const counts = countTransaction;

//   // 2) build rows
//   const headers = [
//     "Date",
//     "Hour",
//     "Solo",
//     "Couple",
//     "Small Group",
//     "Medium Group",
//     "Large Group",
//   ];

//   const csvRows = [headers.join(",")];

//   // assume counts.solo.length entries
//   counts.solo.forEach((_, index) => {
//     const hourLabel = `${index + 5}:00`;
//     const row = {
//       Date:
//         range?.tran_date?.$gte && range?.tran_date?.$lte
//           ? `${new Date(range.tran_date.$gte).toLocaleDateString("en-US", {
//               year: "numeric",
//               month: "long",
//               day: "numeric",
//             })} - ${new Date(range.tran_date.$lte).toLocaleDateString("en-US", {
//               year: "numeric",
//               month: "long",
//               day: "numeric",
//             })}`
//           : "No date selected",
//       Hour: hourLabel,
//       Solo: counts.solo[index],
//       Couple: counts.couple[index],
//       "Small Group": counts.smallGroup[index],
//       "Medium Group": counts.meduimGroup[index],
//       "Large Group": counts.largeGroup[index],
//     };
//     csvRows.push(Object.values(row).join(","));
//   });

//   // 3) download
//   const csvString = csvRows.join("\n");
//   const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
//   const link = document.createElement("a");
//   const name =
//     fileName ||
//     `TotalGuests_${
//       range?.tran_date?.$gte && range?.tran_date?.$lte
//         ? `${new Date(range.tran_date.$gte).toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "long",
//             day: "numeric",
//           })} - ${new Date(range.tran_date.$lte).toLocaleDateString("en-US", {
//             year: "numeric",
//             month: "long",
//             day: "numeric",
//           })}`
//         : "No date selected"
//     }.csv`;
//   link.href = URL.createObjectURL(blob);
//   link.download = name;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

export async function exportGuestCountsByHourCSV(
  transactions,
  countTransaction,
  range,
  fileName,
) {
  const counts = countTransaction || {};

  const solo = counts.solo || [];
  const couple = counts.couple || [];
  const small = counts.smallGroup || [];
  // NOTE: your key is "meduimGroup" (typo) in CSV code — keep it compatible:
  const medium = counts.meduimGroup || counts.mediumGroup || [];
  const large = counts.largeGroup || [];

  if (!solo.length) {
    console.warn("exportGuestCountsByHourXLSX: no data to export");
    return;
  }

  const gte = range?.tran_date?.$gte ? new Date(range.tran_date.$gte) : null;
  const lte = range?.tran_date?.$lte ? new Date(range.tran_date.$lte) : null;

  const dateRangeLabel =
    gte && lte
      ? `${gte.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })} - ${lte.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}`
      : "No date selected";

  // ===== Build rows (Hour 5:00 -> 4:00 next day) =====
  const rows = solo.map((_, index) => {
    // 0..23 mapped to 5..28 => show 5..23 then 0..4
    const hour = (index + 5) % 24;
    const hourLabel = `${hour.toString().padStart(2, "0")}:00`;

    const Solo = Number(solo[index] ?? 0);
    const Couple = Number(couple[index] ?? 0);
    const SmallGroup = Number(small[index] ?? 0);
    const MediumGroup = Number(medium[index] ?? 0);
    const LargeGroup = Number(large[index] ?? 0);

    return {
      DateRange: dateRangeLabel,
      Hour: hourLabel,
      Solo,
      Couple,
      SmallGroup,
      MediumGroup,
      LargeGroup,
      Total: Solo + Couple + SmallGroup + MediumGroup + LargeGroup,
    };
  });

  // Totals for summary row
  const totals = rows.reduce(
    (acc, r) => {
      acc.Solo += r.Solo;
      acc.Couple += r.Couple;
      acc.SmallGroup += r.SmallGroup;
      acc.MediumGroup += r.MediumGroup;
      acc.LargeGroup += r.LargeGroup;
      acc.Total += r.Total;
      return acc;
    },
    {
      Solo: 0,
      Couple: 0,
      SmallGroup: 0,
      MediumGroup: 0,
      LargeGroup: 0,
      Total: 0,
    },
  );

  // ===== Workbook =====
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Analytics Export";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Guests by Hour", {
    views: [{ state: "frozen", ySplit: 4 }],
  });

  // ===== Title =====
  sheet.mergeCells("A1:H1");
  const titleCell = sheet.getCell("A1");
  titleCell.value = "Total Guests vs. Time of Day (By Group Size)";
  titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
  titleCell.alignment = { vertical: "middle", horizontal: "left" };
  titleCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF1F2937" },
  };
  sheet.getRow(1).height = 26;

  // ===== Meta =====
  sheet.mergeCells("A2:H2");
  const metaCell = sheet.getCell("A2");
  metaCell.value = `Brand: Angels Pizza   |   Date Range: ${dateRangeLabel}`;
  metaCell.font = { italic: true, size: 11, color: { argb: "FF111827" } };
  metaCell.alignment = { vertical: "middle", horizontal: "left" };
  metaCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFF3F4F6" },
  };
  sheet.getRow(2).height = 18;

  sheet.addRow([]);
  sheet.getRow(3).height = 6;

  // ===== Header + Rows =====
  const headers = [
    "Date Range",
    "Hour",
    "Solo (1)",
    "Couple (2)",
    "Small Group (3-5)",
    "Medium Group (6-10)",
    "Large Group (11-15)",
    "Total",
  ];
  sheet.addRow(headers);

  rows.forEach((r) => {
    sheet.addRow([
      r.DateRange,
      r.Hour,
      r.Solo,
      r.Couple,
      r.SmallGroup,
      r.MediumGroup,
      r.LargeGroup,
      r.Total,
    ]);
  });

  // Column widths
  sheet.columns = [
    { width: 34 },
    { width: 10 },
    { width: 12 },
    { width: 12 },
    { width: 18 },
    { width: 18 },
    { width: 16 },
    { width: 10 },
  ];

  const headerRowIndex = 4;
  const firstDataRow = headerRowIndex + 1;
  const lastDataRow = headerRowIndex + rows.length;

  // Style header
  const headerRow = sheet.getRow(headerRowIndex);
  headerRow.height = 18;
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF2563EB" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Body styling (striped) + number formats
  for (let r = firstDataRow; r <= lastDataRow; r++) {
    const row = sheet.getRow(r);
    const isAlt = (r - firstDataRow) % 2 === 1;

    row.eachCell((cell, col) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      if (col <= 2) {
        cell.alignment = { vertical: "middle", horizontal: "left" };
      } else {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.numFmt = "#,##0";
      }

      if (isAlt) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF9FAFB" },
        };
      }
    });
  }

  // ===== Totals row =====
  const totalRowIndex = lastDataRow + 1;
  sheet.getRow(totalRowIndex).height = 18;

  sheet.mergeCells(`A${totalRowIndex}:B${totalRowIndex}`);
  const totalLabelCell = sheet.getCell(`A${totalRowIndex}`);
  totalLabelCell.value = "TOTAL";
  totalLabelCell.font = { bold: true };
  totalLabelCell.alignment = { vertical: "middle", horizontal: "left" };
  totalLabelCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFEFF6FF" },
  };

  const totalsArr = [
    totals.Solo,
    totals.Couple,
    totals.SmallGroup,
    totals.MediumGroup,
    totals.LargeGroup,
    totals.Total,
  ];

  for (let i = 0; i < totalsArr.length; i++) {
    const cell = sheet.getCell(totalRowIndex, 3 + i); // C..H
    cell.value = totalsArr[i];
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.numFmt = "#,##0";
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEFF6FF" },
    };
    cell.border = {
      top: { style: "thin", color: { argb: "FF93C5FD" } },
      left: { style: "thin", color: { argb: "FF93C5FD" } },
      bottom: { style: "thin", color: { argb: "FF93C5FD" } },
      right: { style: "thin", color: { argb: "FF93C5FD" } },
    };
  }

  // Auto-filter
  sheet.autoFilter = {
    from: { row: headerRowIndex, column: 1 },
    to: { row: headerRowIndex, column: headers.length },
  };

  // ===== Download (no file-saver) =====
  const safeName =
    fileName ||
    `TotalGuestsByHour_${dateRangeLabel.replaceAll(",", "").replaceAll(" ", "_")}.xlsx`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = safeName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(link.href), 500);
}
